import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav"]
  static classes = ["scrolled"]
  static values = {
    forceScrolled: { type: Boolean, default: false }
  }

  connect() {
    this.checkScroll = this.checkScroll.bind(this)
    window.addEventListener("scroll", this.checkScroll, { passive: true })
    this.checkScroll() // Check initial state
  }

  disconnect() {
    window.removeEventListener("scroll", this.checkScroll)
  }

  checkScroll() {
    // Force scrolled mode on pages without dark hero sections
    const scrolled = this.forceScrolledValue || window.scrollY > 80

    if (scrolled) {
      this.element.classList.add("nav-scrolled")
    } else {
      this.element.classList.remove("nav-scrolled")
    }
  }
}
